import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=e9f3f5f6&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e9f3f5f6')) {
      api.createRecord('e9f3f5f6', component.options)
    } else {
      api.reload('e9f3f5f6', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=e9f3f5f6&", function () {
      api.rerender('e9f3f5f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2WmM40PbFsFJc/JS/videoIframe.vue"
export default component.exports